function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Fade from "@mui/material/Fade";
import React from "react";
import { DarkBackdrop, LightBackdrop } from "./backdrop";
import { StyledModal } from "./styles";
export const Modal = ({
  backdropColor,
  BackdropComponent,
  children,
  fadeTimeout,
  ...props
}) => /*#__PURE__*/React.createElement(StyledModal, _extends({}, props, {
  slots: {
    backdrop: BackdropComponent !== null && BackdropComponent !== void 0 ? BackdropComponent : backdropColor === "light" ? LightBackdrop : DarkBackdrop
  },
  closeAfterTransition: true,
  "data-qa": "modal"
}), /*#__PURE__*/React.createElement(Fade, {
  in: props.open,
  timeout: fadeTimeout !== null && fadeTimeout !== void 0 ? fadeTimeout : 300
}, children));
Modal.displayName = "Modal";